export default [
  { value: 'csv', label: 'CSV' },
  { value: 'xlsx', label: 'XLSX' },
];
